import { useEffect } from 'react';

import { AppShell } from './app-shell.jsx';

import { Spinner } from '@/components/common/spinner.jsx';
import { ROUTES } from '@/config/routes.js';
import { UserMenu } from '@/features/auth/components/user-menu.jsx';
import { useAuth } from '@/features/auth/hooks/use-auth.js';
import { TeamScopeProvider } from '@/providers/team-scope-provider.jsx';


export function ProtectedAppShell() {
  const { isAuthenticated, isLoading } = useAuth();

  // Unauthenticated visitors to /admin/* land back on the Astro-served
  // marketing homepage. That URL lives outside the SPA's router, so a
  // soft <Navigate> would render the SPA's 404 fallback — we need a
  // real page navigation.
  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      window.location.replace(ROUTES.ROOT);
    }
  }, [isAuthenticated, isLoading]);

  if (isLoading || !isAuthenticated) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  return (
    <TeamScopeProvider>
      <AppShell userMenuSlot={<UserMenu />} />
    </TeamScopeProvider>
  );
}
